import React from 'react';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import FormControl from '@material-ui/core/FormControl';
import Icon from '@material-ui/core/Icon';
import Input from '@material-ui/core/Input';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { match, RouteComponentProps } from 'react-router-dom';
// Components
import { LCAlert } from '../../../../components/alert';
import App from '../../../../components/app';
import ErrorMessage from '../../../../components/error-message';
import EnhancedForm from '../../../../components/form';
import { FormDatas, FormPickerDatas } from '../../../../local-types';
import { TooltipButton } from '../../../../components/tooltip-button';
import Listing from '../../../../components/listing';
import FormOptions from '../../../../components/form/formOptions';
// Modules
import { ErrorPayload, selectors as errorSelectors } from '../../../../redux/reducers/errors';
import {
    actions as pricingActions,
    selectors as pricingSelectors,
    types as pricingTypes,
} from '../../../../redux/reducers/pricing';
import { selectors as pendingSelectors } from '../../../../redux/reducers/pendingOperations';
import { Area, AreaByID, TariffByID, TParams } from '../../../../redux/reducers/api-types';
// Ressources
import FormUtils from '../../../../utils/forms';
import withGlobalStyles from '../../../../utils/global-styles';
import ObjectUtils from '../../../../utils/objectUtils';
import DateUtils from '../../../../utils/dateUtils';
import UserUtils, { AccountRight, RightRank } from '../../../../utils/userUtils';
import { paths } from '../../../paths';
import { ActionLogs } from '../../../../components/action-logs';
import { clsx } from '../../../../utils/htmlUtils';
import { formDefaultConf, generateSurgeOptions } from '../shared';

const queryString = require('query-string');

interface PricesAddTariffHoroProps extends WithTranslation, RouteComponentProps {
    match: match<TParams>;
    globalClasses: any;
    tariffs: TariffByID;
    areas: AreaByID;
    getPricesAddTariffError: ErrorPayload;
    isSavingTariff: boolean;
    getTariff: (id: string) => void;
    createTariff: (payload: any) => void;
    editTariff: (id: string, payload: any) => void;
    deleteTariff: (idp: string, idt: any) => void;
    getAreas: () => void;
}

interface PricingPricesAddTariffHoroState {
    formData: any;
    formMinPrice: any;
    formMinPricePrebook: any;
    formMinPriceInit: any;
    formModifier: any;
}

enum MinPrice {
    ASAP = 'asap',
    PREBOOK = 'prebook',
    MODIFIER = 'modifier',
}

export class PricingPricesAddTariffHoroPage extends React.Component<
    PricesAddTariffHoroProps,
    PricingPricesAddTariffHoroState
> {
    alertRef: any;
    optionsSurge: FormPickerDatas[];
    optionsModifier: FormPickerDatas[];

    isAdmin: boolean;

    constructor(props: PricesAddTariffHoroProps) {
        super(props);
        const { t, match } = props;
        const id = match.params.id;
        this.isAdmin = UserUtils.checkRightsOrAdmin({ name: AccountRight.PRICING_MGMT, mode: RightRank.W });
        this.state = {
            formMinPrice: ObjectUtils.deepCopy(formDefaultConf),
            formMinPricePrebook: ObjectUtils.deepCopy(formDefaultConf),
            formMinPriceInit: ObjectUtils.deepCopy(formDefaultConf),
            formModifier: {
                modifier_type: 'percent_km',
                ...formDefaultConf,
            },
            formData: {
                type: 'horokilometric',
                pricing_set_id: id,
                pricing_params: {
                    time_settings: {
                        asap: {
                            is_allowed: 'on',
                        },
                        prebook: {
                            is_allowed: 'on',
                            min_delay: 0,
                        },
                    },
                    min_price: {
                        asap: [],
                        prebook: [],
                    },
                    surge: {
                        asap: {},
                        prebook: {},
                    },
                    modifiers: [],
                },
                // "start_area_id": "3a839ff6-7a64-454e-a398-e349d94d0f9b",
                // "is_surge_asap": true,
                // "is_surge_prebook": true,
                // "pricing_params": {
                //   "min_price": PricingPricesAddTariffHoroPage.orderArray([{
                //     "time_slot": { "mon": [{ "start": "08:00", "end": "12:00" }, { "start": "16:00", "end": "20:00" }], "wed": [{ "start": "08:00", "end": "12:00" }, { "start": "16:00", "end": "20:00" }] },
                //     "value": 10,
                //   }, {
                //     "time_slot": { "thu": [{ "start": "00:00", "end": "00:00" }] },
                //     "value": 40
                //   }]),
                //   "km_price": 5,
                //   "minute_price": 2.5,
                //   "service_fees": 2,
                //   "wait_minute_price": 1.5,
                //   "uncharged_wait_minutes": 5,
                //   "cancellation": {
                //     "base_price": 10,
                //     "max_delay": 5
                //   }
                // }
            },
        };

        this.optionsSurge = generateSurgeOptions(t);

        this.optionsModifier = [
            {
                id: 'percent_km',
                name: t('tariffs.modifiers.percent_km', { value: 'X' }),
            },
            {
                id: 'percent_minute',
                name: t('tariffs.modifiers.percent_minute', { value: 'X' }),
            },
            {
                id: 'percent_ride',
                name: t('tariffs.modifiers.percent_ride', { value: 'X' }),
            },
            {
                id: 'amount_ride',
                name: t('tariffs.modifiers.amount_ride', { value: 'X' }),
            },
        ];
    }

    componentDidMount() {
        const { location, getTariff, getAreas } = this.props;
        const { edit_id } = queryString.parse(location.search);
        if (edit_id) {
            getTariff(edit_id);
        }
        getAreas();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.match.params.id !== (this.props.match.params as any).id) {
            const id = this.props.match.params.id;
            this.props.getTariff(id);
        }
    }

    static getDerivedStateFromProps(props: PricesAddTariffHoroProps, state: PricingPricesAddTariffHoroState) {
        const { edit_id } = queryString.parse(props.location.search);
        const { tariffs } = props;
        const { formData } = state;

        if (!formData.loaded && tariffs && tariffs[edit_id]) {
            const formatedData: any = ObjectUtils.deepCopy(tariffs[edit_id]);
            if (!formatedData.pricing_params?.min_price) {
                formatedData.pricing_params = {
                    ...formatedData.pricing_params,
                    min_price: {
                        asap: [],
                        prebook: [],
                    },
                };
            }

            formatedData.pricing_params.min_price.asap = PricingPricesAddTariffHoroPage.orderArray(
                formatedData.pricing_params.min_price.asap,
            );
            formatedData.pricing_params.min_price.prebook = PricingPricesAddTariffHoroPage.orderArray(
                formatedData.pricing_params.min_price.prebook,
            );

            if (formatedData?.pricing_params?.cancellation?.ride_price_rate) {
                formatedData.pricing_params.cancellation.ride_price_rate = parseFloat(
                    (formatedData.pricing_params.cancellation.ride_price_rate * 100).toFixed(2),
                );
            }

            const prebook = formatedData?.pricing_params?.surge?.prebook;
            const asap = formatedData?.pricing_params?.surge?.asap;
            if (prebook?.warranty_price === 0) {
                prebook.surge_no_variation = 'off';
            } else if (prebook?.warranty_price > 0) {
                prebook.surge_no_variation = 'on';
                prebook.surge_no_variation_price = prebook.warranty_price;
            }

            if (prebook?.is_enabled === 0) {
                prebook.is_enabled = 'off';
            } else if (prebook?.is_enabled === 1) {
                prebook.is_enabled = 'on';
            }

            if (asap?.is_enabled === 0) {
                asap.is_enabled = 'off';
            } else if (asap?.is_enabled === 1) {
                asap.is_enabled = 'on';
            }

            formatedData.pricing_params.modifiers = PricingPricesAddTariffHoroPage.orderModifierArray(
                formatedData.pricing_params,
            );

            const time_settings = formatedData?.pricing_params?.time_settings;
            if (time_settings) {
                // eslint-disable-next-line @typescript-eslint/no-shadow
                const { asap, prebook } = time_settings;

                if (prebook?.is_allowed === 0) {
                    prebook.is_allowed = 'off';
                } else if (prebook?.is_allowed === 1) {
                    prebook.is_allowed = 'on';
                }

                if (prebook?.min_delay > 0) {
                    prebook.min_delay /= 60;
                }

                if (asap?.is_allowed === 0) {
                    asap.is_allowed = 'off';
                } else if (asap?.is_allowed === 1) {
                    asap.is_allowed = 'on';
                }
            }

            formatedData.loaded = true;
            // console.log('==>', formatedData);
            return { formData: formatedData };
        }
        return null;
    }

    static orderArray(array, boToServer: boolean = false): Array<any> {
        const res = [];
        if (!array) {
            return res;
        }
        if (!boToServer) {
            array.forEach((v) => {
                Object.entries(v.time_slot).forEach(([day, slots]: [string, Array<any>]) => {
                    slots.forEach((s) => {
                        const idx = res.find((o) => o.start === s.start && o.end === s.end && o.value === v.value);
                        if (!idx) {
                            res.push({
                                start: s.start,
                                end: s.end,
                                value: v.value,
                                days: [{ short: day, value: true }],
                            });
                        } else {
                            idx.days.push({ short: day, value: true });
                        }
                    });
                });
            });
        } else {
            array.forEach((v) => {
                v.days
                    .filter((d) => d.value)
                    .forEach(({ short, value }) => {
                        const idx = res.find((o) => o.value === v.value);
                        if (!idx) {
                            const tmp = {};
                            tmp[short] = [{ start: v.start, end: v.end }];
                            res.push({
                                value: v.value,
                                time_slot: tmp,
                            });
                        } else {
                            const slotdx = Object.keys(idx.time_slot).find((o) => o === short);
                            if (!slotdx) {
                                idx.time_slot[short] = [{ start: v.start, end: v.end }];
                            } else {
                                idx.time_slot[slotdx].push({ start: v.start, end: v.end });
                            }
                        }
                    });
            });
        }
        return res;
    }

    static orderModifierArray(array, boToServer: boolean = false): any {
        if (!boToServer) {
            const res = [];
            if (!array) {
                return res;
            }
            const obj = array; // receive as object
            Object.entries(obj).forEach(([key, types]: [string, any]) => {
                if (key.endsWith('_price_modifier')) {
                    Object.entries(types).forEach(([subkey, values]: [string, any]) => {
                        const type = subkey + '_' + (key.split('_')?.[0] ?? 'ukn');
                        values.forEach((v) => {
                            const formatedValue = subkey === 'percent' ? v.value * 100 : v.value;
                            Object.entries(v.time_slot).forEach(([day, slots]: [string, Array<any>]) => {
                                slots.forEach((s) => {
                                    const idx = res.find(
                                        (o) => o.start === s.start && o.end === s.end && o.value === formatedValue,
                                    );
                                    if (!idx) {
                                        res.push({
                                            start: s.start,
                                            end: s.end,
                                            value: formatedValue,
                                            modifier_type: type,
                                            days: [{ short: day, value: true }],
                                        });
                                    } else {
                                        idx.days.push({ short: day, value: true });
                                    }
                                });
                            });
                        });
                    });
                }
            });
            return res;
        } else {
            const res = {
                ride_price_modifier: { amount: [], percent: [] },
                km_price_modifier: { percent: [] },
                minute_price_modifier: { percent: [] },
            };
            if (!array) {
                return res;
            }
            array.forEach((v) => {
                const [type, key] = v.modifier_type.split('_');
                const fullKey = key + '_price_modifier';
                v.days
                    .filter((d) => d.value)
                    .forEach(({ short, value }) => {
                        const formatedValue = type === 'percent' ? v.value / 100 : v.value;
                        const idx = res[fullKey][type].find((o) => o.value === formatedValue);
                        if (!idx) {
                            const tmp = {};
                            tmp[short] = [{ start: v.start, end: v.end }];
                            res[fullKey][type].push({
                                value: formatedValue,
                                time_slot: tmp,
                            });
                        } else {
                            const slotdx = Object.keys(idx.time_slot).find((o) => o === short);
                            if (!slotdx) {
                                idx.time_slot[short] = [{ start: v.start, end: v.end }];
                            } else {
                                idx.time_slot[slotdx].push({ start: v.start, end: v.end });
                            }
                        }
                    });
            });
            return res;
        }
    }

    //========================================//
    //=============== Handlers ===============//
    //========================================//

    handleChipsActivate = (index, listingMode: MinPrice) => (e) => {
        e.stopPropagation();
        e.preventDefault();

        const { formMinPrice, formMinPricePrebook, formModifier } = this.state;
        if (listingMode === MinPrice.ASAP) {
            formMinPrice.days[index].value = !formMinPrice.days[index].value;
            this.setState({
                formMinPrice,
            });
        } else if (listingMode === MinPrice.PREBOOK) {
            formMinPricePrebook.days[index].value = !formMinPricePrebook.days[index].value;
            this.setState({
                formMinPricePrebook,
            });
        } else {
            formModifier.days[index].value = !formModifier.days[index].value;
            this.setState({
                formModifier,
            });
        }
    };

    handleChange = (event, listingMode: MinPrice) => {
        const { formMinPrice, formMinPricePrebook, formModifier } = this.state;
        if (listingMode === MinPrice.ASAP) {
            this.setState({
                formMinPrice: FormUtils.nextSubState(event, formMinPrice),
            });
        } else if (listingMode === MinPrice.PREBOOK) {
            this.setState({
                formMinPricePrebook: FormUtils.nextSubState(event, formMinPricePrebook),
            });
        } else {
            this.setState({
                formModifier: FormUtils.nextSubState(event, formModifier),
            });
        }
    };

    handleDelete = (index, listingMode: MinPrice) => (e) => {
        const { formData } = this.state;

        if (listingMode === MinPrice.ASAP) {
            formData.pricing_params.min_price.asap.splice(index, 1);
        } else if (listingMode === MinPrice.PREBOOK) {
            formData.pricing_params.min_price.prebook.splice(index, 1);
        } else {
            formData.pricing_params.modifiers.splice(index, 1);
        }
        this.setState({
            formData,
        });
    };

    handleSubmitAsap = (e) => {
        this.handleSubmit(e, MinPrice.ASAP);
    };

    handleSubmitPrebook = (e) => {
        this.handleSubmit(e, MinPrice.PREBOOK);
    };

    handleSubmitModifier = (e) => {
        this.handleSubmit(e, MinPrice.MODIFIER);
    };

    handleSubmit = (e, listingMode: MinPrice) => {
        e.preventDefault();
        const { formData, formMinPrice, formMinPricePrebook, formMinPriceInit, formModifier } = this.state;

        if (!formData.pricing_params.min_price?.asap) {
            formData.pricing_params.min_price = { ...formData.pricing_params.min_price, asap: [] };
        }

        if (!formData.pricing_params.min_price?.prebook) {
            formData.pricing_params.min_price = { ...formData.pricing_params.min_price, prebook: [] };
        }

        if (!formData.pricing_params.modifiers) {
            formData.pricing_params.modifiers = [];
        }

        if (listingMode === MinPrice.ASAP) {
            formData.pricing_params.min_price.asap.push(Object.assign({}, formMinPrice));
            // console.log('ASAP', formData);

            this.setState({
                formData,
                formMinPrice: Object.assign({}, formMinPriceInit),
            });
        } else if (listingMode === MinPrice.PREBOOK) {
            formData.pricing_params.min_price.prebook.push(Object.assign({}, formMinPricePrebook));
            // console.log('PREBOOK', formData);

            this.setState({
                formData,
                formMinPricePrebook: Object.assign({}, formMinPriceInit),
            });
        } else {
            formData.pricing_params.modifiers.push(Object.assign({}, formModifier));
            // console.log('MODIFIER', formData);
            const resetModifierForm = Object.assign({}, formMinPriceInit);
            resetModifierForm.modifier_type = 'percent_km';
            this.setState({
                formData,
                formModifier: resetModifierForm,
            });
        }
    };

    handleTariffReset = (): void => {
        const { formData } = this.state;
        formData.pricing_params = {
            ...formData.pricing_params,
            min_price: { asap: [], prebook: [] },
            time_settings: {
                asap: {
                    is_allowed: 'on',
                },
                prebook: {
                    is_allowed: 'on',
                    min_delay: 0,
                },
            },
        };

        this.setState({
            formData,
        });
    };

    //========================================//
    //=============== Builders ===============//
    //========================================//

    renderFormMin = (listingMode: MinPrice, formMinPrice): JSX.Element => {
        const { formData } = this.state;
        const { t, globalClasses } = this.props;

        let listing = formData?.pricing_params?.min_price?.asap;
        let form = 'form_min_price';
        if (listingMode === MinPrice.PREBOOK) {
            listing = formData?.pricing_params?.min_price?.prebook;
            form = 'form_min_price_prebook';
        }

        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', margin: 'auto', marginBottom: 30 }}>
                        {DateUtils.generateDays(t).map((d, index) => {
                            const activated = formMinPrice.days[index].value;
                            return (
                                <Chip
                                    key={d.id}
                                    icon={null}
                                    color={activated ? 'secondary' : 'default'}
                                    label={d.label}
                                    onClick={this.handleChipsActivate(index, listingMode)}
                                    style={{ marginRight: 8 }}
                                    // className={classes.chip}
                                />
                            );
                        })}
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            marginBottom: 50,
                        }}
                    >
                        <span style={{ margin: 'auto' }}>{t('common:from')}</span>
                        <FormControl key={'start'} margin="dense">
                            <Input
                                id={'start'}
                                type={'time'}
                                inputProps={{ form }}
                                placeholder={'_:_'}
                                value={formMinPrice.start ?? ''}
                                name={`start`}
                                required={true}
                                onChange={(e) => this.handleChange(e, listingMode)}
                            />
                        </FormControl>
                        <span style={{ margin: 'auto' }}>{t('common:hour_to')}</span>
                        <FormControl key={'end'} margin="dense">
                            <Input
                                id={'end'}
                                type={'time'}
                                inputProps={{ form }}
                                placeholder={'_:_'}
                                value={formMinPrice.end ?? ''}
                                name={`end`}
                                required={true}
                                onChange={(e) => this.handleChange(e, listingMode)}
                            />
                        </FormControl>
                        <span style={{ margin: 'auto' }}>{t('common:price')}</span>
                        <FormControl key={'value'} margin="dense" style={{ width: 50 }}>
                            <Input
                                id={'value'}
                                type={'number'}
                                inputProps={{ form, step: 0.01 }}
                                placeholder={'10'}
                                value={formMinPrice.value ?? ''}
                                name={`value`}
                                required={true}
                                onChange={(e) => this.handleChange(e, listingMode)}
                            />
                        </FormControl>
                        <span style={{ margin: 'auto' }}>{t('common:euro_ht')}</span>
                        <TooltipButton title={t('common:add')}>
                            <Button
                                aria-label="filter list"
                                type="submit"
                                variant="contained"
                                form={form}
                                color={
                                    formMinPrice.start &&
                                    formMinPrice.end &&
                                    formMinPrice.value !== null &&
                                    String(formMinPrice.value).length > 0
                                        ? 'secondary'
                                        : 'inherit'
                                }
                            >
                                <Icon fontSize="small">add</Icon>
                            </Button>
                        </TooltipButton>
                    </div>
                </div>
                <Listing
                    datas={listing?.map(({ days, end, start, value }, index) => {
                        const sortedDays = ObjectUtils.sortByDay(days);
                        const strDays = sortedDays
                            .filter((d) => d.value)
                            .map(({ short }, dindex) => t('common:days.' + short))
                            .join(', ');
                        return (
                            <div
                                key={`${value} ${strDays} ${start} ${end}`}
                                style={{
                                    flex: 'inherit',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <div style={{ marginRight: 6, flex: 4 }}>
                                    <b>{strDays}</b>
                                    <br />
                                    <span>
                                        {`${t('common:hour_from')} ${start} 
                                                ${t('common:hour_to')} ${end}`}
                                    </span>
                                </div>
                                <div style={{ marginRight: 6, flex: 1 }}>
                                    <b>{`${value} ${t('common:euro_ht')}`}</b>
                                </div>
                                {this.isAdmin && (
                                    <TooltipButton title={t('common:delete')}>
                                        <Button
                                            size="small"
                                            variant="contained"
                                            color="primary"
                                            onClick={this.handleDelete(index, listingMode)}
                                            className={clsx(globalClasses.btnAutoWidth, globalClasses.btnDanger)}
                                        >
                                            <Icon fontSize="small">delete</Icon>
                                        </Button>
                                    </TooltipButton>
                                )}
                            </div>
                        );
                    })}
                />
            </div>
        );
    };

    renderFormModifiers = (listingMode: MinPrice, formModifier): JSX.Element => {
        const { formData } = this.state;
        const { t, globalClasses } = this.props;

        const listing = formData?.pricing_params?.modifiers;
        const form = 'form_modifier';

        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', margin: 'auto', marginBottom: 30 }}>
                        {DateUtils.generateDays(t).map((d, index) => {
                            const activated = formModifier.days[index].value;
                            return (
                                <Chip
                                    key={d.id}
                                    icon={null}
                                    color={activated ? 'secondary' : 'default'}
                                    label={d.label}
                                    onClick={this.handleChipsActivate(index, listingMode)}
                                    style={{ marginRight: 8 }}
                                    // className={classes.chip}
                                />
                            );
                        })}
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            marginBottom: 50,
                        }}
                    >
                        <span style={{ margin: 'auto' }}>{t('common:from')}</span>
                        <FormControl key={'start'} margin="dense">
                            <Input
                                id={'start'}
                                type={'time'}
                                inputProps={{ form }}
                                placeholder={'_:_'}
                                value={formModifier.start ?? ''}
                                name={`start`}
                                required={true}
                                onChange={(e) => this.handleChange(e, listingMode)}
                            />
                        </FormControl>
                        <span style={{ margin: 'auto' }}>{t('common:hour_to')}</span>
                        <FormControl key={'end'} margin="dense">
                            <Input
                                id={'end'}
                                type={'time'}
                                inputProps={{ form }}
                                placeholder={'_:_'}
                                value={formModifier.end ?? ''}
                                name={`end`}
                                required={true}
                                onChange={(e) => this.handleChange(e, listingMode)}
                            />
                        </FormControl>
                        <FormControl key={'modifier'} margin="dense" style={{ margin: 0 }}>
                            <FormOptions
                                id={'modifier_type'}
                                name={'modifier_type'}
                                value={formModifier.modifier_type ?? ''}
                                noEmpty={true}
                                options={this.optionsModifier}
                                multipleOptions={false}
                                optionsGroups={null}
                                required={true}
                                label={''}
                                style={{ minWidth: 'auto', fontSize: 'small' }}
                                handleChange={(e) => this.handleChange(e, listingMode)}
                            />
                        </FormControl>
                        <span style={{ margin: 'auto' }}>{t('X')}</span>
                        <FormControl key={'value'} margin="dense" style={{ width: 50 }}>
                            <Input
                                id={'value'}
                                type={'number'}
                                inputProps={{ form, step: 0.01 }}
                                placeholder={'10'}
                                value={formModifier.value ?? ''}
                                name={`value`}
                                onChange={(e) => this.handleChange(e, listingMode)}
                            />
                        </FormControl>
                        <TooltipButton title={t('common:add')}>
                            <Button
                                aria-label="filter list"
                                type="submit"
                                variant="contained"
                                form={form}
                                color={
                                    formModifier.start &&
                                    formModifier.end &&
                                    formModifier.type &&
                                    formModifier.value !== null &&
                                    String(formModifier.value).length > 0
                                        ? 'secondary'
                                        : 'inherit'
                                }
                            >
                                <Icon fontSize="small">add</Icon>
                            </Button>
                        </TooltipButton>
                    </div>
                </div>
                <Listing
                    datas={listing?.map(({ days, end, start, value, modifier_type }, index) => {
                        const sortedDays = ObjectUtils.sortByDay(days);
                        const strDays = sortedDays
                            .filter((d) => d.value)
                            .map(({ short }, dindex) => t('common:days.' + short))
                            .join(', ');
                        return (
                            <div
                                key={`${value} ${strDays} ${start} ${end}`}
                                style={{
                                    flex: 'inherit',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <div style={{ marginRight: 6, flex: 4 }}>
                                    <b>{strDays}</b>
                                    <br />
                                    <span>
                                        {`${t('common:hour_from')} ${start} 
                                                ${t('common:hour_to')} ${end}`}
                                    </span>
                                </div>
                                <div style={{ marginRight: 6, flex: 1 }}>
                                    <b>{t(`tariffs.modifiers.${modifier_type}`, { value })}</b>
                                </div>
                                {this.isAdmin && (
                                    <TooltipButton title={t('common:delete')}>
                                        <Button
                                            size="small"
                                            variant="contained"
                                            color="primary"
                                            onClick={this.handleDelete(index, listingMode)}
                                            className={clsx(globalClasses.btnAutoWidth, globalClasses.btnDanger)}
                                        >
                                            <Icon fontSize="small">delete</Icon>
                                        </Button>
                                    </TooltipButton>
                                )}
                            </div>
                        );
                    })}
                />
            </div>
        );
    };

    generateInputs = (): FormDatas[] => {
        const { t, areas, match } = this.props;
        const id = match.params.id;
        const placeholder = t('tariffs.surge_options.inherit');

        const inputs: FormDatas[] = [
            {
                title: t(id ? 'tariffs.edit' : 'tariffs.new'),
                datas: [
                    {
                        id: 'start_area_id',
                        label: t('tariffs.start_area'),
                        type: 'picker',
                        searchable: true,
                        required: true,
                    },
                    {
                        id: 'pricing_params[km_price]',
                        label: t('tariffs.price_km'),
                        placeholder,
                        type: 'number',
                    },
                    {
                        id: 'pricing_params[minute_price]',
                        label: t('tariffs.price_minute'),
                        placeholder,
                        type: 'number',
                    },
                    {
                        id: 'pricing_params[service_fees]',
                        label: t('tariffs.price_take'),
                        placeholder,
                        type: 'number',
                    },
                    {
                        id: 'pricing_params[wait_minute_price]',
                        label: t('tariffs.price_minute_wait'),
                        placeholder,
                        type: 'number',
                    },
                    {
                        id: 'pricing_params[uncharged_wait_minutes]',
                        label: t('tariffs.free_minute_wait'),
                        placeholder,
                        type: 'number',
                        inputsAttributs: { step: 1 },
                    },
                ],
            },
            {
                title: t('tariffs.cancellation'),
                datas: [
                    {
                        id: 'pricing_params.cancellation.base_price_prebook',
                        label: t('tariffs.price_cancellation_prebook'),
                        placeholder,
                        type: 'number',
                    },
                    {
                        id: 'pricing_params.cancellation.base_price_asap',
                        label: t('tariffs.price_cancellation_asap'),
                        placeholder,
                        type: 'number',
                    },
                    {
                        id: 'pricing_params.cancellation.max_delay',
                        label: t('tariffs.time_cancellation_prebook'),
                        placeholder,
                        type: 'number',
                        inputsAttributs: { step: 1 },
                    },
                    {
                        id: 'pricing_params.cancellation.ride_price_rate',
                        label: t('tariffs.cancellation_ride_price_rate'),
                        placeholder,
                        type: 'number',
                        inputsAttributs: { step: 0.01, min: 0, max: 100 },
                    },
                ],
            },
            {
                title: t('tariffs.surge'),
                datas: [
                    {
                        id: 'pricing_params.surge.asap.is_enabled',
                        label: t('tariffs.surge_asap'),
                        type: 'picker',
                        options: this.optionsSurge,
                        noEmpty: true,
                    },
                    {
                        id: 'pricing_params.surge.prebook.is_enabled',
                        label: t('tariffs.surge_prebook'),
                        type: 'picker',
                        options: this.optionsSurge,
                        noEmpty: true,
                    },
                    {
                        id: 'pricing_params.surge.prebook.surge_no_variation',
                        label: t('tariffs.surge_no_variation'),
                        type: 'picker',
                        options: this.optionsSurge,
                        noEmpty: true,
                    },
                    {
                        id: 'pricing_params.surge.prebook.surge_no_variation_price',
                        label: t('tariffs.surge_no_variation_price'),
                        type: 'number',
                        hint: t('tariffs.surge_no_variation_price_hint'),
                        inputsAttributs: { step: 0.01, min: 0 },
                        required: true,
                        linked: { id: 'pricing_params.surge.prebook.surge_no_variation', value: 'on' },
                    },
                ],
            },
            {
                title: t('tariffs.time_settings.title'),
                datas: [
                    {
                        id: 'pricing_params.time_settings.asap.is_allowed',
                        label: t('tariffs.time_settings.asap'),
                        type: 'picker',
                        options: this.optionsSurge,
                        noEmpty: true,
                    },
                    {
                        id: 'pricing_params.time_settings.prebook.is_allowed',
                        label: t('tariffs.time_settings.prebook'),
                        type: 'picker',
                        options: this.optionsSurge,
                        noEmpty: true,
                    },
                    {
                        id: 'pricing_params.time_settings.prebook.min_delay',
                        label: t('tariffs.time_settings.prebook_min_delay'),
                        type: 'number',
                        inputsAttributs: { step: 0.01, min: 0 },
                        linked: { id: 'pricing_params.time_settings.prebook.is_allowed', value: 'on' },
                    },
                ],
            },
            {
                title: t('tariffs.min_price'),
                datas: [
                    {
                        id: 'pricing_params.min_price',
                        label: t('tariffs.min_price'),
                        type: 'create',
                        customView: () => {
                            const { formMinPrice } = this.state;
                            return this.renderFormMin(MinPrice.ASAP, formMinPrice);
                        },
                    },
                ],
            },
            {
                title: t('tariffs.min_price_prebook'),
                datas: [
                    {
                        id: 'pricing_params.min_price_prebook',
                        label: t('tariffs.min_price_prebook'),
                        type: 'create',
                        customView: () => {
                            const { formMinPricePrebook } = this.state;
                            return this.renderFormMin(MinPrice.PREBOOK, formMinPricePrebook);
                        },
                    },
                ],
            },
            {
                title: t('tariffs.modifiers.title'),
                datas: [
                    {
                        id: 'pricing_params.modifiers',
                        label: t('tariffs.modifiers.title'),
                        type: 'create',
                        customView: () => {
                            const { formModifier } = this.state;
                            return this.renderFormModifiers(MinPrice.MODIFIER, formModifier);
                        },
                    },
                ],
            },
        ];

        if (areas) {
            inputs[0].datas.find((d) => d.id === 'start_area_id').options = Object.values(areas).map((r: Area) => {
                return { id: r.id, name: r.name };
            });
        }

        return inputs;
    };

    static formatSurgePickerToBoolean = (value: any) => {
        if (value === 'on') {
            return true;
        } else if (value === 'off') {
            return false;
        } else {
            return null;
        }
    };

    onSubmitTariff = (formData, event) => {
        if (!this.isAdmin) {
            return;
        }

        // Apply custom field min_price to the formData
        formData.pricing_params.min_price = this.state.formData.pricing_params?.min_price;

        // let data = new FormData(event.target);
        this.setState({
            formData: formData,
        });

        const formatedData = ObjectUtils.deepCopy(formData);
        delete formatedData.loaded;

        const tmpMinPriceAsap = PricingPricesAddTariffHoroPage.orderArray(
            formatedData.pricing_params.min_price.asap,
            true,
        );
        const tmpMinPricePrebook = PricingPricesAddTariffHoroPage.orderArray(
            formatedData.pricing_params.min_price.prebook,
            true,
        );
        formatedData.pricing_params.min_price = { asap: tmpMinPriceAsap, prebook: tmpMinPricePrebook };

        if (formatedData?.pricing_params?.cancellation?.ride_price_rate) {
            formatedData.pricing_params.cancellation.ride_price_rate /= 100;
        }

        if (formatedData.pricing_params.min_price.asap.length === 0) {
            delete formatedData.pricing_params.min_price.asap;
        }
        if (formatedData.pricing_params.min_price.prebook.length === 0) {
            delete formatedData.pricing_params.min_price.prebook;
        }

        if (ObjectUtils.isEmpty(formatedData.pricing_params.min_price)) {
            delete formatedData.pricing_params.min_price;
        }
        if (ObjectUtils.isEmpty(formatedData.pricing_params)) {
            delete formatedData.pricing_params;
        }

        // Format surge picker
        if (formatedData.pricing_params.surge?.prebook) {
            formatedData.pricing_params.surge.prebook.is_enabled =
                PricingPricesAddTariffHoroPage.formatSurgePickerToBoolean(
                    formatedData.pricing_params.surge.prebook.is_enabled,
                );
        }
        if (formatedData.pricing_params.surge?.asap) {
            formatedData.pricing_params.surge.asap.is_enabled =
                PricingPricesAddTariffHoroPage.formatSurgePickerToBoolean(
                    formatedData.pricing_params.surge.asap.is_enabled,
                );
        }

        // Format surge warranty_price
        if (formatedData.pricing_params.surge?.prebook?.surge_no_variation === 'on') {
            formatedData.pricing_params.surge.prebook.warranty_price =
                formatedData.pricing_params.surge.prebook.surge_no_variation_price;
        } else if (formatedData.pricing_params.surge?.prebook?.surge_no_variation === 'off') {
            formatedData.pricing_params.surge.prebook.warranty_price = 0;
        } else if (formatedData.pricing_params.surge?.prebook?.warranty_price >= 0) {
            delete formatedData.pricing_params.surge.prebook.warranty_price;
        }

        if (formatedData.pricing_params.surge?.prebook?.surge_no_variation) {
            delete formatedData.pricing_params.surge.prebook.surge_no_variation;
        }
        if (formatedData.pricing_params.surge?.prebook?.surge_no_variation_price) {
            delete formatedData.pricing_params.surge.prebook.surge_no_variation_price;
        }

        // Format modifiers
        const tmpModifiers = PricingPricesAddTariffHoroPage.orderModifierArray(
            formatedData.pricing_params.modifiers,
            true,
        );
        formatedData.pricing_params = { ...formatedData.pricing_params, ...tmpModifiers };
        if (formatedData.pricing_params?.modifiers) {
            delete formatedData.pricing_params.modifiers;
        }

        // Format time_settings picker
        if (formatedData.pricing_params.time_settings?.prebook) {
            const prebook = formatedData.pricing_params.time_settings.prebook;
            prebook.is_allowed = PricingPricesAddTariffHoroPage.formatSurgePickerToBoolean(prebook.is_allowed);
            if (!prebook.is_allowed) {
                delete prebook.min_delay;
            } else {
                if (prebook.min_delay > 0) {
                    prebook.min_delay *= 60;
                }
            }
        }
        if (formatedData.pricing_params.time_settings?.asap) {
            formatedData.pricing_params.time_settings.asap.is_allowed =
                PricingPricesAddTariffHoroPage.formatSurgePickerToBoolean(
                    formatedData.pricing_params.time_settings.asap.is_allowed,
                );
        }

        delete formatedData.history;
        ObjectUtils.cleanEmpty(formatedData);

        const { edit_id } = queryString.parse(this.props.location.search);
        const { editTariff, createTariff } = this.props;

        if (edit_id) {
            editTariff(edit_id, formatedData);
        } else {
            createTariff(formatedData);
        }
    };

    render() {
        const { formData } = this.state;
        const { t, location, match, getPricesAddTariffError, tariffs, isSavingTariff } = this.props;
        const { edit_id } = queryString.parse(location.search);

        const id: string = match.params.id;
        const formPayload = edit_id ? formData : { ...formData, loaded: true };

        return (
            <App needRights={{ name: AccountRight.PRICING_MGMT, mode: RightRank.R }}>
                <ErrorMessage payload={getPricesAddTariffError} />
                <LCAlert
                    onRef={(ref) => (this.alertRef = ref)}
                    details={t('tariffs.missing_price_forfait')}
                    type="error"
                    open={false}
                />
                {formPayload?.loaded && (
                    <>
                        <form onSubmit={this.handleSubmitAsap} id="form_min_price">
                            <input type="submit" hidden value="Ok" />
                        </form>
                        <form onSubmit={this.handleSubmitPrebook} id="form_min_price_prebook">
                            <input type="submit" hidden value="Ok" />
                        </form>
                        <form onSubmit={this.handleSubmitModifier} id="form_modifier">
                            <input type="submit" hidden value="Ok" />
                        </form>
                        <EnhancedForm
                            payload={formPayload}
                            inputs={this.generateInputs()}
                            backRoute={`${paths.pricingManagePrices}/${id}`}
                            onReset={this.handleTariffReset}
                            onSubmit={this.onSubmitTariff}
                            readOnly={!this.isAdmin}
                            actionBarHidden={!this.isAdmin}
                            loader={isSavingTariff}
                        />
                        <ActionLogs history={tariffs?.[edit_id]?.history} withValues allValues />
                    </>
                )}
            </App>
        );
    }
}

const PricingPricesAddTariffHoroPageWithTranslation = withGlobalStyles(
    withTranslation(['pricing', 'common'])(PricingPricesAddTariffHoroPage),
);

const mapStateToProps = (state) => ({
    areas: pricingSelectors.areas(state),
    tariffs: pricingSelectors.tariffs(state),
    getPricesAddTariffError: errorSelectors.getPricesAddTariffError(state),
    isSavingTariff: pendingSelectors.isPending(state, pricingTypes.CREATE_TARIFF, pricingTypes.EDIT_TARIFF),
});

const mapDispatchToProps = {
    getTariff: pricingActions.getTariff,
    createTariff: pricingActions.createTariff,
    editTariff: pricingActions.editTariff,
    deleteTariff: pricingActions.deleteTariff,
    getAreas: pricingActions.getAreas,
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingPricesAddTariffHoroPageWithTranslation);
